// import React, { useState, useEffect } from "react";
// import config from "../../Common/Configurations/APIConfig";
// import apiService from "../../Common/Configurations/APIService";
// import Header from "../../Common/Layout/Header";
// import { useAuth } from "../../Common/Configurations/AuthContext";
// import { useNavigate } from "react-router-dom";
// import HotelTabs from "../../Components/AllTabs/HotelTabs";

// const PropertiesList = () => {
//     const { user, loading } = useAuth();
//     const navigate = useNavigate();
    
//     // State for properties
//     const [properties, setProperties] = useState([]);
//     const [isLoading, setIsLoading] = useState(true);
//     const [error, setError] = useState(null);
    
//     // Property details modal
//     const [showDetailsModal, setShowDetailsModal] = useState(false);
//     const [selectedPropertyDetails, setSelectedPropertyDetails] = useState(null);
    
//     // Pagination
//     const [currentPage, setCurrentPage] = useState(1);
//     const [resultsPerPage] = useState(12);

//     // Fetch properties on component mount
//     useEffect(() => {
//         if (user && !loading) {
//             fetchProperties();
//         }
//     }, [user, loading]);

//     // API call to get all properties
//     const fetchProperties = async () => {
//         setIsLoading(true);
//         setError(null);
        
//         try {
//             const response = await apiService.getAll(
//                 `${config.GETCOMPANYHOTELS}`
//             );
            
//             const fetchedProperties = response.hotels || response.data || [];
//             setProperties(fetchedProperties);
            
//             // Reset to first page
//             setCurrentPage(1);
//         } catch (error) {
//             console.error("Error fetching properties:", error);
//             setError("Failed to load properties. Please try again.");
//         } finally {
//             setIsLoading(false);
//         }
//     };

//     // Get lowest room price for a property
//     const getLowestRoomPrice = (roomDetails) => {
//         if (!roomDetails || roomDetails.length === 0) {
//             return null;
//         }
        
//         const validRooms = roomDetails.filter(room => room.price && !isNaN(room.price));
//         if (validRooms.length === 0) return null;
        
//         const lowest = validRooms.reduce((min, room) => 
//             room.price < min.price ? room : min
//         , validRooms[0]);
        
//         return {
//             price: lowest.price,
//             currency: lowest.currency,
//             roomType: lowest.roomType
//         };
//     };

//     // Get validity dates with better formatting
//     const getValidityDates = (roomDetails) => {
//         if (!roomDetails || roomDetails.length === 0) return null;
        
//         let validFrom = null;
//         let validTo = null;
        
//         roomDetails.forEach(room => {
//             if (room.validFrom && room.validFrom !== 'Not specified') {
//                 const fromDate = new Date(room.validFrom);
//                 if (!validFrom || fromDate < validFrom) validFrom = fromDate;
//             }
//             if (room.validTo && room.validTo !== 'Not specified') {
//                 const toDate = new Date(room.validTo);
//                 if (!validTo || toDate > validTo) validTo = toDate;
//             }
//         });
        
//         return {
//             from: validFrom ? formatDate(validFrom) : null,
//             to: validTo ? formatDate(validTo) : null,
//             isActive: validFrom && validTo ? new Date() >= validFrom && new Date() <= validTo : false
//         };
//     };

//     // Open property details modal
//     const openDetailsModal = (property) => {
//         setSelectedPropertyDetails(property);
//         setShowDetailsModal(true);
//     };

//     // Close property details modal
//     const closeDetailsModal = () => {
//         setShowDetailsModal(false);
//         setSelectedPropertyDetails(null);
//     };

//     // Handle WhatsApp click with pre-filled message
//     const handleWhatsAppClick = (property, e) => {
//         e.stopPropagation(); // Prevent card click event
        
//         if (!property.contactInfo?.whatsApp) {
//             alert("WhatsApp number not available for this property");
//             return;
//         }
        
//         const cleanNumber = property.contactInfo.whatsApp.replace(/\D/g, '');
        
//         // Create a pre-filled message with property details
//         const message = `Hello! 👋\n\nI'm interested in your property *${property.hotelName}* located in ${property.city}, ${property.country}.\n\n` +
//          `Could you please provide more information about availability and rates?\n\n` +
//             `Here are my details:\n` +
//             `• Agency: ${user?.companyname || 'Not specified'}\n` +
//             `• Name: ${user?.name || 'Not specified'}\n` +
//             `• Email: ${user?.email || 'Not specified'}\n` +
//             `• Phone: ${user?.phoneNumber || 'Not specified'}\n\n` +
           
//             `Thank you! 😊`;
        
//         const encodedMessage = encodeURIComponent(message);
       
//   window.open(`https://web.whatsapp.com/send?text=${encodedMessage}`, '_blank');

      
//     };

//     // Handle Email click with pre-filled subject and body
//     const handleEmailClick = (property, e) => {
//         e.stopPropagation(); // Prevent card click event
        
//         if (!property.contactInfo?.email) {
//             alert("Email address not available for this property");
//             return;
//         }
        
//         const subject = `Enquiry for ${property.hotelName} - ${user?.companyname || ''}`;
        
//         const body = `Dear DMC,\n\n` +
//             `I am writing to enquire about your property "${property.hotelName}" located in ${property.city}, ${property.country}.\n\n` +
//             `Here are my details:\n` +
//             `• Company Name: ${user?.companyname || 'Not specified'}\n` +
//             `• Contact Person: ${user?.name || 'Not specified'}\n` +
//             `• Email: ${user?.email || 'Not specified'}\n` +
//             `• Phone: ${user?.phoneNumber || 'Not specified'}\n\n` +
//             `Please provide information regarding:\n` +
//             `1. Room availability and rates\n` +
//             `2. Meal plan options\n` +
//             `3. Cancellation policy\n` +
//             `4. Any special offers or packages\n\n` +
//             `Looking forward to your response.\n\n` +
//             `Best regards,\n` +
//             `${user?.name || ''}\n` +
//             `${user?.companyname || ''}`;
        
//         const encodedSubject = encodeURIComponent(subject);
//         const encodedBody = encodeURIComponent(body);
        
//         // Open default email client with pre-filled content
//         window.open(`mailto:${property.contactInfo.email}?subject=${encodedSubject}&body=${encodedBody}`, '_blank');
//     };

//     // Render star rating
//     const renderStars = (rating) => {
//         const stars = [];
//         const fullStars = Math.floor(rating);
//         const hasHalfStar = rating % 1 >= 0.5;

//         for (let i = 1; i <= 5; i++) {
//             if (i <= fullStars) {
//                 stars.push(<i key={i} className="bi bi-star-fill text-warning" style={{ fontSize: '12px' }}></i>);
//             } else if (i === fullStars + 1 && hasHalfStar) {
//                 stars.push(<i key={i} className="bi bi-star-half text-warning" style={{ fontSize: '12px' }}></i>);
//             } else {
//                 stars.push(<i key={i} className="bi bi-star text-warning" style={{ fontSize: '12px' }}></i>);
//             }
//         }
//         return <span className="d-inline-flex align-items-center">{stars}</span>;
//     };

//     // Format currency
//     const formatCurrency = (amount, currency) => {
//         const symbols = {
//             'INR': '₹',
//             'USD': '$',
//             'EUR': '€',
//             'GBP': '£',
//             'AED': 'AED ',
//             'SGD': 'S$',
//             'AUD': 'A$',
//             'CAD': 'C$'
//         };
        
//         const symbol = symbols[currency] || currency;
//         return `${symbol}${amount}`;
//     };

//     // Get meal plan label
//     const getMealPlanLabel = (mealPlan) => {
//         const plans = {
//             'CP': 'CP → Breakfast only',
//             'MAP': 'MAP → Breakfast + Lunch or Dinner',
//             'AP': 'AP → Breakfast + Lunch + Dinner',
//             'EP': 'EP → Room only',
//             'CPAI': 'CPAI → Stay + Breakfast',
//             'MAPAI': 'MAPAI → Stay + Breakfast + Lunch/Dinner',
//             'APAI': 'APAI → Stay + Breakfast + Lunch + Dinner'
//         };
//         return plans[mealPlan] || mealPlan;
//     };

//     // Format date to display
//     const formatDate = (dateString) => {
//         if (!dateString || dateString === 'Not specified') return 'N/A';
        
//         try {
//             const date = new Date(dateString);
//             return date.toLocaleDateString('en-US', {
//                 day: '2-digit',
//                 month: 'short',
//                 year: 'numeric'
//             });
//         } catch (error) {
//             return dateString;
//         }
//     };

//     // Get validity period for room details
//     const getValidityPeriod = (roomDetails) => {
//         if (!roomDetails || roomDetails.length === 0) return 'N/A';
        
//         let earliestDate = null;
//         let latestDate = null;
        
//         roomDetails.forEach(room => {
//             if (room.validFrom && room.validFrom !== 'Not specified') {
//                 const fromDate = new Date(room.validFrom);
//                 if (!earliestDate || fromDate < earliestDate) {
//                     earliestDate = fromDate;
//                 }
//             }
            
//             if (room.validTo && room.validTo !== 'Not specified') {
//                 const toDate = new Date(room.validTo);
//                 if (!latestDate || toDate > latestDate) {
//                     latestDate = toDate;
//                 }
//             }
//         });
        
//         if (earliestDate && latestDate) {
//             return `${formatDate(earliestDate)} to ${formatDate(latestDate)}`;
//         } else if (earliestDate) {
//             return `From ${formatDate(earliestDate)}`;
//         } else if (latestDate) {
//             return `Until ${formatDate(latestDate)}`;
//         }
        
//         return 'N/A';
//     };

//     // Pagination calculations
//     const indexOfLastResult = currentPage * resultsPerPage;
//     const indexOfFirstResult = indexOfLastResult - resultsPerPage;
//     const currentResults = properties.slice(indexOfFirstResult, indexOfLastResult);
//     const totalPages = Math.ceil(properties.length / resultsPerPage);

//     if (loading) return <p>Loading...</p>;

//     if (!user) {
//         navigate("/");
//     }

//     return (
//         <div id="layout-wrapper">
//             <Header User={user} />
//             <div className="main-content">
//                 <div className="page-content">
//                     <div className="container-fluid">
//                         <div className="card">
//                             <div className="p-2">
//                                 <HotelTabs pageName="PROPERTIES" />
//                             </div>
//                             <div className="card-body p-3">
//                                 <div className="row mb-3">
//                                     <div className="col-12">
//                                         <div className="d-flex align-items-center mb-3">
//                                             <div className="flex-grow-1">
//                                                 <h6 className="card-title text-primary mb-0">
//                                                     <i className="bi bi-buildings me-2"></i>
//                                                     Available Properties ({properties.length})
//                                                 </h6>
//                                                 <small className="text-muted">
//                                                     Browse and contact DMCs directly via WhatsApp or Email
//                                                 </small>
//                                             </div>
//                                             <button
//                                                 className="btn btn-outline-primary btn-sm"
//                                                 onClick={fetchProperties}
//                                                 disabled={isLoading}
//                                             >
//                                                 <i className="bi bi-arrow-clockwise me-2"></i>
//                                                 {isLoading ? "Refreshing..." : "Refresh"}
//                                             </button>
//                                         </div>

//                                         {/* Loading State */}
//                                         {isLoading && (
//                                             <div className="text-center py-4">
//                                                 <div className="spinner-border text-primary spinner-border-sm" role="status">
//                                                     <span className="visually-hidden">Loading...</span>
//                                                 </div>
//                                                 <p className="mt-2 small">
//                                                     Loading properties...
//                                                 </p>
//                                             </div>
//                                         )}

//                                         {/* Error State */}
//                                         {error && !isLoading && (
//                                             <div className="alert alert-danger text-center py-3">
//                                                 <i className="bi bi-exclamation-triangle mb-2 text-danger" style={{ fontSize: '32px' }}></i>
//                                                 <h6 className="mb-2">Error Loading Properties</h6>
//                                                 <p className="small text-muted mb-2">{error}</p>
//                                                 <button
//                                                     type="button"
//                                                     className="btn btn-outline-primary btn-sm"
//                                                     onClick={fetchProperties}
//                                                 >
//                                                     Try Again
//                                                 </button>
//                                             </div>
//                                         )}

//                                         {/* No Properties State */}
//                                         {!isLoading && !error && properties.length === 0 && (
//                                             <div className="text-center py-4">
//                                                 <i className="bi bi-buildings mb-2 text-muted" style={{ fontSize: '48px' }}></i>
//                                                 <h6 className="mb-2">
//                                                     No Properties Available
//                                                 </h6>
//                                                 <p className="small text-muted mb-3">
//                                                     There are no properties available at the moment.
//                                                 </p>
//                                             </div>
//                                         )}

//                                         {/* Properties List */}
//                                         {!isLoading && !error && properties.length > 0 && (
//                                             <>
//                                                 <div className="d-flex justify-content-between align-items-center mb-3 p-2 bg-light rounded">
//                                                     <div>
//                                                         <small className="fw-bold">
//                                                             {properties.length} Properties
//                                                         </small>
//                                                         <small className="text-muted d-block">
//                                                             Showing {currentResults.length} of {properties.length}
//                                                         </small>
//                                                     </div>
//                                                     <div>
//                                                         <small className="text-muted">
//                                                             Page {currentPage}/{totalPages}
//                                                         </small>
//                                                     </div>
//                                                 </div>

//                                                 <div className="row row-cols-1 row-cols-md-2 row-cols-lg-3 row-cols-xl-4 g-3 mb-3">
//                                                     {currentResults.map((property, index) => {
//                                                         const lowestPrice = getLowestRoomPrice(property.roomDetails);
//                                                         const validityDates = getValidityDates(property.roomDetails);
                                                        
//                                                         return (
//                                                             <div key={property.companyHotelId || index} className="col">
//                                                                 <div 
//                                                                     className="card h-100 property-card border-light"
//                                                                     style={{ 
//                                                                         cursor: 'pointer',
//                                                                         transition: 'all 0.2s ease',
//                                                                         boxShadow: '0 1px 3px rgba(0,0,0,0.1)'
//                                                                     }}
//                                                                 >
//                                                                     <div className="position-relative">
//                                                                         {property.hotelImage ? (
//                                                                             <img
//                                                                                 src={property.hotelImage}
//                                                                                 className="card-img-top"
//                                                                                 alt={property.hotelName}
//                                                                                 style={{ height: '140px', objectFit: 'cover', width: '100%' }}
//                                                                                 onError={(e) => {
//                                                                                     e.target.onerror = null;
//                                                                                     e.target.src = `https://via.placeholder.com/300x140/cccccc/666666?text=${encodeURIComponent(property.hotelName?.substring(0, 20) || 'Property')}`;
//                                                                                 }}
//                                                                             />
//                                                                         ) : (
//                                                                             <div className="card-img-top bg-gradient-primary d-flex align-items-center justify-content-center"
//                                                                                  style={{ height: '140px', background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)' }}>
//                                                                                 <i className="bi bi-building text-white" style={{ fontSize: '36px' }}></i>
//                                                                             </div>
//                                                                         )}
//                                                                         {property.isOwner && (
//                                                                             <span className="position-absolute top-0 start-0 m-1 badge bg-success" style={{ fontSize: '10px' }}>
//                                                                                 <i className="bi bi-check-circle me-1" style={{ fontSize: '10px' }}></i>Owner
//                                                                             </span>
//                                                                         )}
//                                                                         <span className="position-absolute top-0 end-0 m-1 badge bg-info" style={{ fontSize: '10px' }}>
//                                                                             <i className="bi bi-tag me-1" style={{ fontSize: '10px' }}></i>DMC
//                                                                         </span>
//                                                                     </div>
                                                                    
//                                                                     <div className="card-body p-2">
//                                                                         {/* Property Name with Star Rating */}
//                                                                         <div className="d-flex justify-content-between align-items-start mb-1">
//                                                                             <h6 className="card-title text-truncate mb-0 me-1" style={{ fontSize: '14px' }}>
//                                                                                 {property.hotelName}
//                                                                             </h6>
//                                                                             <div className="d-flex align-items-center flex-shrink-0">
//                                                                                 {renderStars(property.starRating || 0)}
//                                                                                 <span className="ms-1 fw-bold text-warning" style={{ fontSize: '11px' }}>
//                                                                                     {property.starRating || 'N/A'}
//                                                                                 </span>
//                                                                             </div>
//                                                                         </div>
                                                                        
//                                                                         {/* Location */}
//                                                                         <div className="d-flex align-items-center text-muted small mb-1">
//                                                                             <i className="bi bi-geo-alt me-1 flex-shrink-0" style={{ fontSize: '11px' }}></i>
//                                                                             <span className="text-truncate" style={{ fontSize: '11px' }}>
//                                                                                 {[property.city, property.country].filter(Boolean).join(', ')}
//                                                                             </span>
//                                                                         </div>
                                                                        
//                                                                         {/* Lowest Room Price - Starts From */}
//                                                                         {lowestPrice && (
//                                                                             <div className="mb-1 p-1 bg-success bg-opacity-10 rounded">
//                                                                                 <small className="text-success d-flex align-items-center" style={{ fontSize: '11px' }}>
//                                                                                     <i className="bi bi-tag-fill me-1" style={{ fontSize: '11px' }}></i>
//                                                                                     <span className="fw-bold">Prices Starts from:</span>
//                                                                                     <span className="ms-1 fw-bold text-success">
//                                                                                         {formatCurrency(lowestPrice.price, lowestPrice.currency)}
//                                                                                     </span>
//                                                                                 </small>
//                                                                             </div>
//                                                                         )}
                                                                        
//                                                                         {/* Validity Dates - From and To */}
//                                                                         {validityDates && (validityDates.from || validityDates.to) ? (
//                                                                             <div className="mb-1 p-1 bg-light rounded">
//                                                                                 <div className="d-flex align-items-center text-muted">
//                                                                                     <i className="bi bi-calendar-check me-1 text-primary" style={{ fontSize: '11px' }}></i>
//                                                                                     <div style={{ fontSize: '10px' }}>
//                                                                                         {validityDates.from && (
//                                                                                             <span className="me-1">
//                                                                                                 <span className="fw-bold">Valid From:</span> {validityDates.from}
//                                                                                             </span>
//                                                                                         )}
//                                                                                         {validityDates.to && (
//                                                                                             <span>
//                                                                                                 <span className="fw-bold ms-1">To:</span> {validityDates.to}
//                                                                                             </span>
//                                                                                         )}
//                                                                                         {validityDates.isActive && (
//                                                                                             <span className="badge bg-success ms-1" style={{ fontSize: '8px', padding: '2px 4px' }}>Active</span>
//                                                                                         )}
//                                                                                     </div>
//                                                                                 </div>
//                                                                             </div>
//                                                                         ) : (
//                                                                             <div className="mb-1 p-1 bg-light rounded">
//                                                                                 <small className="text-muted d-flex align-items-center" style={{ fontSize: '10px' }}>
//                                                                                     <i className="bi bi-calendar-x me-1"></i>
//                                                                                     No validity period
//                                                                                 </small>
//                                                                             </div>
//                                                                         )}
                                                                        
//                                                                         {/* Room Details Available - Compact */}
//                                                                         {property.roomDetails?.length > 0 && (
//                                                                             <div className="mb-1">
//                                                                                 <small className="text-success d-flex align-items-center" style={{ fontSize: '10px' }}>
//                                                                                     <i className="bi bi-check-circle me-1 flex-shrink-0" style={{ fontSize: '10px' }}></i>
//                                                                                     <span>{property.roomDetails.length} room type(s)</span>
//                                                                                 </small>
//                                                                             </div>
//                                                                         )}
                                                                        
//                                                                         {/* Property Type and Country Code - Compact */}
//                                                                         <div className="mb-1">
//                                                                             <span className="badge bg-primary bg-opacity-10 text-primary me-1" style={{ fontSize: '9px', padding: '2px 4px' }}>
//                                                                                 {property.accommodationType || 'Hotel'}
//                                                                             </span>
//                                                                             {property.countryCode && (
//                                                                                 <span className="badge bg-info bg-opacity-10 text-info me-1" style={{ fontSize: '9px', padding: '2px 4px' }}>
//                                                                                     <i className="bi bi-flag me-1" style={{ fontSize: '9px' }}></i>
//                                                                                     {property.countryCode}
//                                                                                 </span>
//                                                                             )}
//                                                                         </div>
//                                                                     </div>
                                                                    
//                                                                     <div className="card-footer bg-transparent border-top p-2">
//                                                                         <div className="row g-1">
//                                                                             {/* View Details & Prices Button */}
//                                                                             <div className="col-12">
//                                                                                 <button
//                                                                                     type="button"
//                                                                                     className="btn btn-primary w-100"
//                                                                                     style={{ padding: '3px 6px', fontSize: '11px' }}
//                                                                                     onClick={(e) => {
//                                                                                         e.stopPropagation();
//                                                                                         openDetailsModal(property);
//                                                                                     }}
//                                                                                 >
//                                                                                     <i className="bi bi-eye me-1" style={{ fontSize: '11px' }}></i>
//                                                                                     <i className="bi bi-tag ms-1" style={{ fontSize: '11px' }}></i>
//                                                                                     View Details & Prices
//                                                                                 </button>
//                                                                             </div>
                                                                            
//                                                                             {/* Contact Buttons */}
//                                                                             <div className="col-6">
//                                                                                 <button
//                                                                                     type="button"
//                                                                                     className="btn btn-success w-100"
//                                                                                     style={{ padding: '3px 6px', fontSize: '11px' }}
//                                                                                     onClick={(e) => handleWhatsAppClick(property, e)}
//                                                                                     disabled={!property.contactInfo?.whatsApp}
//                                                                                     title={property.contactInfo?.whatsApp ? 
//                                                                                         `Contact via WhatsApp: ${property.contactInfo.whatsApp}` : 
//                                                                                         'WhatsApp not available'}
//                                                                                 >
//                                                                                     <i className="bi bi-whatsapp me-1" style={{ fontSize: '11px' }}></i>
//                                                                                     WhatsApp
//                                                                                 </button>
//                                                                             </div>
                                                                            
//                                                                             <div className="col-6">
//                                                                                 <button
//                                                                                     type="button"
//                                                                                     className="btn btn-info w-100"
//                                                                                     style={{ padding: '3px 6px', fontSize: '11px' }}
//                                                                                     onClick={(e) => handleEmailClick(property, e)}
//                                                                                     disabled={!property.contactInfo?.email}
//                                                                                     title={property.contactInfo?.email ? 
//                                                                                         `Contact via Email: ${property.contactInfo.email}` : 
//                                                                                         'Email not available'}
//                                                                                 >
//                                                                                     <i className="bi bi-envelope me-1" style={{ fontSize: '11px' }}></i>
//                                                                                     Email
//                                                                                 </button>
//                                                                             </div>
//                                                                         </div>
//                                                                     </div>
//                                                                 </div>
//                                                             </div>
//                                                         );
//                                                     })}
//                                                 </div>
                                                
//                                                 {/* Pagination - Compact */}
//                                                 {totalPages > 1 && (
//                                                     <nav aria-label="Properties pagination" className="mt-3">
//                                                         <ul className="pagination pagination-sm justify-content-center flex-wrap mb-0">
//                                                             <li className={`page-item ${currentPage === 1 ? 'disabled' : ''}`}>
//                                                                 <button
//                                                                     className="page-link"
//                                                                     onClick={() => setCurrentPage(1)}
//                                                                     disabled={currentPage === 1}
//                                                                     style={{ padding: '4px 8px', fontSize: '11px' }}
//                                                                 >
//                                                                     First
//                                                                 </button>
//                                                             </li>
//                                                             <li className={`page-item ${currentPage === 1 ? 'disabled' : ''}`}>
//                                                                 <button
//                                                                     className="page-link"
//                                                                     onClick={() => setCurrentPage(prev => Math.max(1, prev - 1))}
//                                                                     disabled={currentPage === 1}
//                                                                     style={{ padding: '4px 8px', fontSize: '11px' }}
//                                                                 >
//                                                                     Prev
//                                                                 </button>
//                                                             </li>
                                                            
//                                                             {Array.from({ length: Math.min(3, totalPages) }, (_, i) => {
//                                                                 let pageNum;
//                                                                 if (totalPages <= 3) {
//                                                                     pageNum = i + 1;
//                                                                 } else if (currentPage <= 2) {
//                                                                     pageNum = i + 1;
//                                                                 } else if (currentPage >= totalPages - 1) {
//                                                                     pageNum = totalPages - 2 + i;
//                                                                 } else {
//                                                                     pageNum = currentPage - 1 + i;
//                                                                 }
                                                                
//                                                                 return (
//                                                                     <li key={pageNum} className={`page-item ${currentPage === pageNum ? 'active' : ''}`}>
//                                                                         <button
//                                                                             className="page-link"
//                                                                             onClick={() => setCurrentPage(pageNum)}
//                                                                             style={{ padding: '4px 8px', fontSize: '11px' }}
//                                                                         >
//                                                                             {pageNum}
//                                                                         </button>
//                                                                     </li>
//                                                                 );
//                                                             })}
                                                            
//                                                             <li className={`page-item ${currentPage === totalPages ? 'disabled' : ''}`}>
//                                                                 <button
//                                                                     className="page-link"
//                                                                     onClick={() => setCurrentPage(prev => Math.min(totalPages, prev + 1))}
//                                                                     disabled={currentPage === totalPages}
//                                                                     style={{ padding: '4px 8px', fontSize: '11px' }}
//                                                                 >
//                                                                     Next
//                                                                 </button>
//                                                             </li>
//                                                             <li className={`page-item ${currentPage === totalPages ? 'disabled' : ''}`}>
//                                                                 <button
//                                                                     className="page-link"
//                                                                     onClick={() => setCurrentPage(totalPages)}
//                                                                     disabled={currentPage === totalPages}
//                                                                     style={{ padding: '4px 8px', fontSize: '11px' }}
//                                                                 >
//                                                                     Last
//                                                                 </button>
//                                                             </li>
//                                                         </ul>
//                                                     </nav>
//                                                 )}
//                                             </>
//                                         )}
//                                     </div>
//                                 </div>
//                             </div>
//                         </div>
//                     </div>
//                 </div>
//             </div>

//             {/* Property Details Modal - Keep existing modal code */}
//             {showDetailsModal && selectedPropertyDetails && (
//                 <div className="modal fade show" style={{ display: 'block', backgroundColor: 'rgba(0,0,0,0.5)' }}>
//                     <div className="modal-dialog modal-xl modal-dialog-centered modal-dialog-scrollable">
//                         <div className="modal-content">
//                             <div className="modal-header bg-primary py-2">
//                                 <h6 className="modal-title text-white">
//                                     <i className="bi bi-building me-2 text-white"></i>
//                                     {selectedPropertyDetails.hotelName}
//                                 </h6>
//                                 <button 
//                                     type="button" 
//                                     className="btn-close btn-close-white"
//                                     onClick={closeDetailsModal}
//                                     style={{ fontSize: '12px' }}
//                                 ></button>
//                             </div>
//                           <div className="modal-body">
//                                 <div className="row">
//                                     {/* Left Column - Image and Basic Info */}
//                                      <div className="col-md-4">
//                                         {/* Property Image */}
//                                        <div className="mb-3">
//                                             {selectedPropertyDetails.hotelImage ? (
//                                                 <img
//                                                     src={selectedPropertyDetails.hotelImage}
//                                                     className="img-fluid rounded shadow"
//                                                     alt={selectedPropertyDetails.hotelName}
//                                                     style={{ 
//                                                         width: '100%', 
//                                                         height: '250px',
//                                                         objectFit: 'cover'
//                                                     }}
//                                                     onError={(e) => {
//                                                         e.target.onerror = null;
//                                                         e.target.src = `https://via.placeholder.com/400x250/cccccc/666666?text=${encodeURIComponent(selectedPropertyDetails.hotelName?.substring(0, 30) || 'Property')}`;
//                                                     }}
//                                                 />
//                                             ) : (
//                                                 <div 
//                                                     className="bg-gradient-primary rounded shadow d-flex align-items-center justify-content-center"
//                                                     style={{ 
//                                                         height: '250px',
//                                                         background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)'
//                                                     }}
//                                                 >
//                                                     <i className="bi bi-building text-white" style={{ fontSize: '64px' }}></i>
//                                                 </div>
//                                             )}
//                                         </div>
                                        
//                                         {/* Star Rating */}
//                                         <div className="card border-warning mb-3">
//                                             <div className="card-body text-center">
//                                                 <h6 className="card-title text-warning mb-2">
//                                                     <i className="bi bi-star me-1"></i>
//                                                     Star Rating
//                                                 </h6>
//                                                 <div className="d-flex justify-content-center align-items-center">
//                                                     {renderStars(selectedPropertyDetails.starRating || 0)}
//                                                     <span className="ms-2 fw-bold fs-5">
//                                                         {selectedPropertyDetails.starRating || 'N/A'} Star
//                                                     </span>
//                                                 </div>
//                                             </div>
//                                         </div>
                                        
//                                         {/* Property Type */}
//                                         <div className="card border-primary mb-3">
//                                             <div className="card-body text-center">
//                                                 <h6 className="card-title text-primary mb-2">
//                                                     <i className="bi bi-building me-1"></i>
//                                                     Property Type
//                                                 </h6>
//                                                 <h4 className="text-primary mb-0">
//                                                     {selectedPropertyDetails.accommodationType || 'Hotel'}
//                                                 </h4>
//                                             </div>
//                                         </div>
                                        
                                       
                                        
//                                         {/* Contact Buttons */}
//                                         {selectedPropertyDetails.contactInfo && (
//                                             <div className="card border-info">
//                                                 <div className="card-body text-center">
//                                                     <h6 className="card-title text-info mb-3">
//                                                         <i className="bi bi-telephone me-1"></i>
//                                                         Contact DMC Directly
//                                                     </h6>
//                                                     <div className="d-grid gap-2">
//                                                         {selectedPropertyDetails.contactInfo.whatsApp && (
//                                                             <button
//                                                                 className="btn btn-success"
//                                                                 onClick={(e) => handleWhatsAppClick(selectedPropertyDetails, e)}
//                                                             >
//                                                                 <i className="bi bi-whatsapp me-2"></i>
//                                                                 WhatsApp
//                                                             </button>
//                                                         )}
//                                                         {selectedPropertyDetails.contactInfo.email && (
//                                                             <button
//                                                                 className="btn btn-primary"
//                                                                 onClick={(e) => handleEmailClick(selectedPropertyDetails, e)}
//                                                             >
//                                                                 <i className="bi bi-envelope me-2"></i>
//                                                                 Send Email
//                                                             </button>
//                                                         )}
//                                                     </div>
//                                                 </div>
//                                             </div>
//                                         )}
//                                     </div>
                                    
//                                     {/* Right Column - Details */}
//                                     <div className="col-md-8">
//                                         {/* Location Details */}
//                                         <div className="card border-success mb-3">
//                                             <div className="card-header bg-success bg-opacity-10">
//                                                 <h6 className="mb-0 text-success">
//                                                     <i className="bi bi-geo-alt me-2"></i>
//                                                     Location Details
//                                                 </h6>
//                                             </div>
//                                             <div className="card-body">
//                                                 <div className="row">
//                                                     <div className="col-md-6 mb-2">
//                                                         <strong>Address:</strong>
//                                                         <p className="mb-1">{selectedPropertyDetails.address || 'Not Available'}</p>
//                                                     </div>
//                                                     <div className="col-md-3 mb-2">
//                                                         <strong>City:</strong>
//                                                         <p className="mb-1">{selectedPropertyDetails.city || 'N/A'}</p>
//                                                     </div>
//                                                     <div className="col-md-3 mb-2">
//                                                         <strong>State:</strong>
//                                                         <p className="mb-1">{selectedPropertyDetails.state || 'N/A'}</p>
//                                                     </div>
//                                                     <div className="col-md-4 mb-2">
//                                                         <strong>Country:</strong>
//                                                         <p className="mb-1">{selectedPropertyDetails.country || 'N/A'}</p>
//                                                     </div>
//                                                     <div className="col-md-4 mb-2">
//                                                         <strong>Postal Code:</strong>
//                                                         <p className="mb-1">{selectedPropertyDetails.postalCode || 'N/A'}</p>
//                                                     </div>
//                                                     <div className="col-md-4 mb-2">
//                                                         <strong>Country Code:</strong>
//                                                         <p className="mb-1">{selectedPropertyDetails.countryCode || 'N/A'}</p>
//                                                     </div>
//                                                     {selectedPropertyDetails.latitude && selectedPropertyDetails.longitude && (
//                                                         <div className="col-12">
//                                                             <a
//                                                                 href={`https://www.google.com/maps?q=${selectedPropertyDetails.latitude},${selectedPropertyDetails.longitude}`}
//                                                                 target="_blank"
//                                                                 rel="noopener noreferrer"
//                                                                 className="btn btn-sm btn-primary"
//                                                             >
//                                                                 <i className="bi bi-geo-alt me-1"></i>
//                                                                 View on Google Maps
//                                                             </a>
//                                                         </div>
//                                                     )}
//                                                 </div>
//                                             </div>
//                                         </div>
                                        
//                                         {/* Contact Details */}
//                                         {selectedPropertyDetails.contactInfo && (
//                                             <div className="card border-info mb-3">
//                                                 <div className="card-header bg-info bg-opacity-10">
//                                                     <h6 className="mb-0 text-info">
//                                                         <i className="bi bi-person me-2"></i>
//                                                         Contact Details
//                                                     </h6>
//                                                 </div>
//                                                 <div className="card-body">
//                                                     <div className="row">
//                                                         <div className="col-md-6 mb-2">
//                                                             <strong>Contact Name:</strong>
//                                                             <p className="mb-1">{selectedPropertyDetails.contactInfo.contactName || 'Not Available'}</p>
//                                                         </div>
//                                                         <div className="col-md-6 mb-2">
//                                                             <strong>Email:</strong>
//                                                             <p className="mb-1">{selectedPropertyDetails.contactInfo.email || 'Not Available'}</p>
//                                                         </div>
//                                                         <div className="col-md-6 mb-2">
//                                                             <strong>Phone:</strong>
//                                                             <p className="mb-1">{selectedPropertyDetails.contactInfo.phone || 'Not Available'}</p>
//                                                         </div>
//                                                         <div className="col-md-6 mb-2">
//                                                             <strong>WhatsApp:</strong>
//                                                             <p className="mb-1">{selectedPropertyDetails.contactInfo.whatsApp || 'Not Available'}</p>
//                                                         </div>
//                                                     </div>
//                                                 </div>
//                                             </div>
//                                         )}
                                        
//                                         {/* Room Details */}
//                                         {selectedPropertyDetails.roomDetails && selectedPropertyDetails.roomDetails.length > 0 && (
//                                             <div className="card border-primary mb-3">
//                                                 <div className="card-header bg-primary bg-opacity-10">
//                                                     <div className="d-flex justify-content-between align-items-center">
//                                                         <h6 className="mb-0 text-primary">
//                                                             <i className="bi bi-bed me-2"></i>
//                                                             Available Room Types
//                                                         </h6>
//                                                         <span className="badge bg-primary">
//                                                             Valid: {getValidityPeriod(selectedPropertyDetails.roomDetails)}
//                                                         </span>
//                                                     </div>
//                                                 </div>
//                                                 <div className="card-body">
//                                                     <div className="table-responsive">
//                                                         <table className="table table-hover">
//                                                             <thead className="table-light">
//                                                                 <tr>
//                                                                     <th>Room Type</th>
//                                                                     <th>Meal Plan</th>
//                                                                     <th>Price</th>
//                                                                     <th>Extra Bed</th>
//                                                                     <th>Child w/o Bed</th>
//                                                                 </tr>
//                                                             </thead>
//                                                             <tbody>
//                                                                 {selectedPropertyDetails.roomDetails.map((room, index) => (
//                                                                     <tr key={index}>
//                                                                         <td>{room.roomType}</td>
//                                                                         <td>{getMealPlanLabel(room.mealPlan)}</td>
//                                                                         <td>
//                                                                             <strong className="text-success">
//                                                                                 {formatCurrency(room.price, room.currency)}
//                                                                             </strong>
//                                                                         </td>
//                                                                         <td>
//                                                                             {room.extraBedPrice ? (
//                                                                                 <span className="badge bg-success">
//                                                                                     {formatCurrency(room.extraBedPrice, room.currency)}
//                                                                                 </span>
//                                                                             ) : (
//                                                                                 <span className="badge bg-secondary">Not Available</span>
//                                                                             )}
//                                                                         </td>
//                                                                         <td>
//                                                                             {room.childWithoutBedPrice ? (
//                                                                                 <span className="badge bg-info">
//                                                                                     {formatCurrency(room.childWithoutBedPrice, room.currency)}
//                                                                                 </span>
//                                                                             ) : (
//                                                                                 <span className="badge bg-secondary">Not Available</span>
//                                                                             )}
//                                                                         </td>
//                                                                     </tr>
//                                                                 ))}
//                                                             </tbody>
//                                                         </table>
//                                                     </div>
//                                                 </div>
//                                             </div>
//                                         )}
                                        
//                                         {/* Amenities */}
//                                         {selectedPropertyDetails.amenities && selectedPropertyDetails.amenities.length > 0 && (
//                                             <div className="card border-success mb-3">
//                                                 <div className="card-header bg-success bg-opacity-10">
//                                                     <h6 className="mb-0 text-success">
//                                                         <i className="bi bi-wifi me-2"></i>
//                                                         Amenities & Facilities
//                                                     </h6>
//                                                 </div>
//                                                 <div className="card-body">
//                                                     <div className="row">
//                                                         {selectedPropertyDetails.amenities.map((amenity, index) => (
//                                                             <div key={index} className="col-md-6 mb-2">
//                                                                 <i className="bi bi-check-circle-fill text-success me-2"></i>
//                                                                 {amenity.point}
//                                                             </div>
//                                                         ))}
//                                                     </div>
//                                                 </div>
//                                             </div>
//                                         )}
                                        
//                                         {/* Policies */}
//                                         <div className="row">
//                                             {/* Terms & Conditions */}
//                                             {selectedPropertyDetails.termsAndConditions && selectedPropertyDetails.termsAndConditions.length > 0 && (
//                                                 <div className="col-md-6 mb-3">
//                                                     <div className="card border-warning h-100">
//                                                         <div className="card-header bg-warning bg-opacity-10">
//                                                             <h6 className="mb-0 text-warning">
//                                                                 <i className="bi bi-file-text me-2"></i>
//                                                                 Terms & Conditions
//                                                             </h6>
//                                                         </div>
//                                                         <div className="card-body">
//                                                             <ul className="list-group list-group-flush">
//                                                                 {selectedPropertyDetails.termsAndConditions.slice(0, 5).map((term, index) => (
//                                                                     <li key={index} className="list-group-item px-0">
//                                                                         <i className="bi bi-dot text-warning me-2"></i>
//                                                                         {term.point}
//                                                                     </li>
//                                                                 ))}
//                                                             </ul>
//                                                         </div>
//                                                     </div>
//                                                 </div>
//                                             )}
                                            
//                                             {/* Cancellation Policy */}
//                                             {selectedPropertyDetails.cancellationPolicy && selectedPropertyDetails.cancellationPolicy.length > 0 && (
//                                                 <div className="col-md-6 mb-3">
//                                                     <div className="card border-danger h-100">
//                                                         <div className="card-header bg-danger bg-opacity-10">
//                                                             <h6 className="mb-0 text-danger">
//                                                                 <i className="bi bi-calendar-x me-2"></i>
//                                                                 Cancellation Policy
//                                                             </h6>
//                                                         </div>
//                                                         <div className="card-body">
//                                                             <ul className="list-group list-group-flush">
//                                                                 {selectedPropertyDetails.cancellationPolicy.slice(0, 5).map((policy, index) => (
//                                                                     <li key={index} className="list-group-item px-0">
//                                                                         <i className="bi bi-dot text-danger me-2"></i>
//                                                                         {policy.point}
//                                                                     </li>
//                                                                 ))}
//                                                             </ul>
//                                                         </div>
//                                                     </div>
//                                                 </div>
//                                             )}
//                                         </div>
//                                     </div>
//                                 </div>
//                             </div>
//                             <div className="modal-footer">
//                                 <button
//                                     type="button"
//                                     className="btn btn-secondary"
//                                     onClick={closeDetailsModal}
//                                 >
//                                     Close
//                                 </button>
//                             </div>
//                         </div>
//                         </div>
//                     </div>
            
                
//             )}

//             {/* Custom CSS */}
//             <style jsx>{`
//                 .property-card:hover {
//                     border-color: #0d6efd !important;
//                     box-shadow: 0 2px 5px rgba(0,0,0,0.1) !important;
//                 }
                
//                 .property-card {
//                     font-size: 12px;
//                 }
                
//                 .card-body {
//                     padding: 0.5rem !important;
//                 }
                
//                 .card-footer {
//                     padding: 0.5rem !important;
//                 }
                
//                 .badge {
//                     font-weight: 500;
//                 }
                
//                 .btn-success {
//                     background-color: #25d366;
//                     border-color: #25d366;
//                 }
                
//                 .btn-success:hover {
//                     background-color: #1da851;
//                     border-color: #1da851;
//                 }
                
//                 .btn-info {
//                     background-color: #0dcaf0;
//                     border-color: #0dcaf0;
//                 }
                
//                 .btn-info:hover {
//                     background-color: #0ba6c8;
//                     border-color: #0ba6c8;
//                 }
                
//                 .btn-success:disabled, .btn-info:disabled {
//                     opacity: 0.5;
//                     cursor: not-allowed;
//                 }
                
//                 @media (max-width: 768px) {
//                     .container-fluid {
//                         padding-left: 10px;
//                         padding-right: 10px;
//                     }
                    
//                     .row {
//                         margin-left: -5px;
//                         margin-right: -5px;
//                     }
                    
//                     .col {
//                         padding-left: 5px;
//                         padding-right: 5px;
//                     }
                    
//                     .card-footer .row {
//                         margin: 0 -2px;
//                     }
                    
//                     .card-footer .col-6 {
//                         padding: 0 2px;
//                     }
//                 } 
//             `}</style>
//         </div>
//     );
// };

// export default PropertiesList;


import React, { useState, useEffect } from "react";
import config from "../../Common/Configurations/APIConfig";
import apiService from "../../Common/Configurations/APIService";
import Header from "../../Common/Layout/Header";
import { useAuth } from "../../Common/Configurations/AuthContext";
import { useNavigate } from "react-router-dom";
import HotelTabs from "../../Components/AllTabs/HotelTabs";

const PropertiesList = () => {
    const { user, loading } = useAuth();
    const navigate = useNavigate();
    
    // State for properties
    const [properties, setProperties] = useState([]);
    const [isLoading, setIsLoading] = useState(true);
    const [error, setError] = useState(null);
    
    // Enquiry state
    const [showEnquiryModal, setShowEnquiryModal] = useState(false);
    const [selectedProperty, setSelectedProperty] = useState(null);
    const [enquiryData, setEnquiryData] = useState({
        checkIn: "",
        checkOut: "",
        adults: 1,
        children: 0,
        rooms: 1,
        customerName: "",
        customerEmail: "",
        customerPhone: "",
        specialRequests: "",
        roomPreference: ""
    });
    const [isSubmittingEnquiry, setIsSubmittingEnquiry] = useState(false);
    
    // Property details modal
    const [showDetailsModal, setShowDetailsModal] = useState(false);
    const [selectedPropertyDetails, setSelectedPropertyDetails] = useState(null);
    
    // Pagination
    const [currentPage, setCurrentPage] = useState(1);
    const [resultsPerPage] = useState(12);

    // Fetch properties on component mount
    useEffect(() => {
        if (user && !loading) {
            fetchProperties();
        }
    }, [user, loading]);

    // API call to get all properties
    const fetchProperties = async () => {
        setIsLoading(true);
        setError(null);
        
        try {
            const response = await apiService.getAll(
                `${config.GETCOMPANYHOTELS}`
            );
            
            const fetchedProperties = response.hotels || response.data || [];
            setProperties(fetchedProperties);
            
            // Reset to first page
            setCurrentPage(1);
        } catch (error) {
            console.error("Error fetching properties:", error);
            setError("Failed to load properties. Please try again.");
        } finally {
            setIsLoading(false);
        }
    };

    // Get lowest room price for a property
    const getLowestRoomPrice = (roomDetails) => {
        if (!roomDetails || roomDetails.length === 0) {
            return null;
        }
        
        const validRooms = roomDetails.filter(room => room.price && !isNaN(room.price));
        if (validRooms.length === 0) return null;
        
        const lowest = validRooms.reduce((min, room) => 
            room.price < min.price ? room : min
        , validRooms[0]);
        
        return {
            price: lowest.price,
            currency: lowest.currency,
            roomType: lowest.roomType
        };
    };

    // Get validity dates with better formatting
    const getValidityDates = (roomDetails) => {
        if (!roomDetails || roomDetails.length === 0) return null;
        
        let validFrom = null;
        let validTo = null;
        
        roomDetails.forEach(room => {
            if (room.validFrom && room.validFrom !== 'Not specified') {
                const fromDate = new Date(room.validFrom);
                if (!validFrom || fromDate < validFrom) validFrom = fromDate;
            }
            if (room.validTo && room.validTo !== 'Not specified') {
                const toDate = new Date(room.validTo);
                if (!validTo || toDate > validTo) validTo = toDate;
            }
        });
        
        return {
            from: validFrom ? formatDate(validFrom) : null,
            to: validTo ? formatDate(validTo) : null,
            isActive: validFrom && validTo ? new Date() >= validFrom && new Date() <= validTo : false
        };
    };

    // Open enquiry modal
    const openEnquiryModal = (property) => {
        setSelectedProperty(property);
        
        // Set default dates (tomorrow and day after tomorrow)
        const tomorrow = new Date();
        tomorrow.setDate(tomorrow.getDate() + 1);
        const dayAfterTomorrow = new Date();
        dayAfterTomorrow.setDate(dayAfterTomorrow.getDate() + 2);
        
        setEnquiryData({
            checkIn: tomorrow.toISOString().split('T')[0],
            checkOut: dayAfterTomorrow.toISOString().split('T')[0],
            adults: 1,
            children: 0,
            rooms: 1,
            customerName: user?.name || "",
            customerEmail: user?.email || "",
            customerPhone: user?.phoneNumber || "",
            specialRequests: "",
            roomPreference: ""
        });
        
        setShowEnquiryModal(true);
    };

    // Close enquiry modal
    const closeEnquiryModal = () => {
        setShowEnquiryModal(false);
        setSelectedProperty(null);
        setEnquiryData({
            checkIn: "",
            checkOut: "",
            adults: 1,
            children: 0,
            rooms: 1,
            customerName: "",
            customerEmail: "",
            customerPhone: "",
            specialRequests: "",
            roomPreference: ""
        });
        setIsSubmittingEnquiry(false);
    };

    // Open property details modal
    const openDetailsModal = (property) => {
        setSelectedPropertyDetails(property);
        setShowDetailsModal(true);
    };

    // Close property details modal
    const closeDetailsModal = () => {
        setShowDetailsModal(false);
        setSelectedPropertyDetails(null);
    };

    // Handle enquiry form submission
    const handleEnquirySubmit = async (e) => {
        e.preventDefault();
        setIsSubmittingEnquiry(true);
        
        if (!selectedProperty || !user) {
            alert("Please select a property first.");
            setIsSubmittingEnquiry(false);
            return;
        }
        
        // Validate required fields
        if (!enquiryData.checkIn || !enquiryData.checkOut || 
            !enquiryData.customerName || !enquiryData.customerEmail || !enquiryData.customerPhone) {
            alert("Please fill in all required fields: Check-in, Check-out, Name, Email, and Phone.");
            setIsSubmittingEnquiry(false);
            return;
        }
        
        // Validate dates
        const checkInDate = new Date(enquiryData.checkIn);
        const checkOutDate = new Date(enquiryData.checkOut);
        const today = new Date();
        today.setHours(0, 0, 0, 0);
        
        if (checkInDate < today) {
            alert("Check-in date cannot be in the past.");
            setIsSubmittingEnquiry(false);
            return;
        }
        
        if (checkOutDate <= checkInDate) {
            alert("Check-out date must be after check-in date.");
            setIsSubmittingEnquiry(false);
            return;
        }
        
        try {
            // Create the Lead request object
            const leadRequest = {
                leadId: "00000000-0000-0000-0000-000000000000",
                senderId: user.id,
                senderStatus: "Pending",
                senderTime: new Date().toISOString(),
                receiverId: selectedProperty.userId,
                receiverStatus: "Pending",
                receiverTime: null,
                
                // ServiceDetails - ONLY user entered data
                serviceDetails: {
                    // User entered booking details
                    checkIn: enquiryData.checkIn,
                    checkOut: enquiryData.checkOut,
                    adults: enquiryData.adults,
                    children: enquiryData.children,
                    rooms: enquiryData.rooms,
                    totalGuests: parseInt(enquiryData.adults) + parseInt(enquiryData.children),
                    
                    // User entered special requests
                    specialRequests: enquiryData.specialRequests || "",
                    
                    // User selected room preference (if any)
                    roomPreference: enquiryData.roomPreference || "Not specified",
                    
                    // Property reference (minimal info for identification)
                    propertyName: selectedProperty.hotelName,
                    propertyCity: selectedProperty.city,
                    propertyCountry: selectedProperty.country
                },
                
                // SenderDetails (current user's info)
                senderDetails: {
                    userId: user.id,
                    companyName: user.companyname,
                    senderName: user.name,
                    senderEmail: user.email,
                    senderPhone: user.phoneNumber
                },
                
                // ReceiverDetails (minimal hotel owner info)
                receiverDetails: {
                    propertyOwner: selectedProperty.contactInfo?.contactName || "Hotel Owner",
                    ownerEmail: selectedProperty.contactInfo?.email || "",
                    ownerPhone: selectedProperty.contactInfo?.phone || ""
                },
                
                // Customer contact info (from user input)
                name: enquiryData.customerName,
                email: enquiryData.customerEmail,
                phoneNumber: enquiryData.customerPhone,
                
                // General lead info
                leadStatus: "NEW",
                sourceName: "B2B Portal",
                enquiryType: "HOTEL",
                referenceId: null,
                description: `Hotel enquiry for ${selectedProperty.hotelName} from ${enquiryData.checkIn} to ${enquiryData.checkOut}`,
                callBack: null,
                
                // System fields
                createdDate: new Date().toISOString(),
                updatedDate: new Date().toISOString()
            };
            
            // Call API to create lead
            const response = await apiService.post(
                `${config.CREATELEAD}`,
                leadRequest
            );
            
            if (response.success || response.data) {
                alert("Enquiry submitted successfully! A lead has been created.");
                closeEnquiryModal();
            } else {
                throw new Error("Failed to submit enquiry and create lead");
            }
            
        } catch (error) {
            console.error("Error submitting enquiry:", error);
            alert("Failed to submit enquiry. Please try again.");
        } finally {
            setIsSubmittingEnquiry(false);
        }
    };

    // Handle enquiry form change
    const handleEnquiryChange = (e) => {
        const { name, value } = e.target;
        setEnquiryData(prev => ({
            ...prev,
            [name]: value
        }));
    };

    // Handle number input change
    const handleNumberChange = (e) => {
        const { name, value } = e.target;
        const numValue = parseInt(value) || 0;
        setEnquiryData(prev => ({
            ...prev,
            [name]: numValue
        }));
    };

    // Handle WhatsApp click with pre-filled message
    const handleWhatsAppClick = (property, e) => {
        e.stopPropagation(); // Prevent card click event
        
        if (!property.contactInfo?.whatsApp) {
            alert("WhatsApp number not available for this property");
            return;
        }
        
        const cleanNumber = property.contactInfo.whatsApp.replace(/\D/g, '');
        
        // Create a pre-filled message with property details
        const message = `Hello! 👋\n\nI'm interested in your property *${property.hotelName}* located in ${property.city}, ${property.country}.\n\n` +
         `Could you please provide more information about availability and rates?\n\n` +
            `Here are my details:\n` +
            `• Agency: ${user?.companyname || 'Not specified'}\n` +
            `• Name: ${user?.name || 'Not specified'}\n` +
            `• Email: ${user?.email || 'Not specified'}\n` +
            `• Phone: ${user?.phoneNumber || 'Not specified'}\n\n` +
           
            `Thank you! 😊`;
        
        const encodedMessage = encodeURIComponent(message);
       
  window.open(`https://web.whatsapp.com/send?text=${encodedMessage}`, '_blank');

      
    };

    // Handle Email click with pre-filled subject and body
    const handleEmailClick = (property, e) => {
        e.stopPropagation(); // Prevent card click event
        
        if (!property.contactInfo?.email) {
            alert("Email address not available for this property");
            return;
        }
        
        const subject = `Enquiry for ${property.hotelName} - ${user?.companyname || ''}`;
        
        const body = `Dear DMC,\n\n` +
            `I am writing to enquire about your property "${property.hotelName}" located in ${property.city}, ${property.country}.\n\n` +
            `Here are my details:\n` +
            `• Company Name: ${user?.companyname || 'Not specified'}\n` +
            `• Contact Person: ${user?.name || 'Not specified'}\n` +
            `• Email: ${user?.email || 'Not specified'}\n` +
            `• Phone: ${user?.phoneNumber || 'Not specified'}\n\n` +
            `Please provide information regarding:\n` +
            `1. Room availability and rates\n` +
            `2. Meal plan options\n` +
            `3. Cancellation policy\n` +
            `4. Any special offers or packages\n\n` +
            `Looking forward to your response.\n\n` +
            `Best regards,\n` +
            `${user?.name || ''}\n` +
            `${user?.companyname || ''}`;
        
        const encodedSubject = encodeURIComponent(subject);
        const encodedBody = encodeURIComponent(body);
        
        // Open default email client with pre-filled content
        window.open(`mailto:${property.contactInfo.email}?subject=${encodedSubject}&body=${encodedBody}`, '_blank');
    };

    // Render star rating
    const renderStars = (rating) => {
        const stars = [];
        const fullStars = Math.floor(rating);
        const hasHalfStar = rating % 1 >= 0.5;

        for (let i = 1; i <= 5; i++) {
            if (i <= fullStars) {
                stars.push(<i key={i} className="bi bi-star-fill text-warning" style={{ fontSize: '12px' }}></i>);
            } else if (i === fullStars + 1 && hasHalfStar) {
                stars.push(<i key={i} className="bi bi-star-half text-warning" style={{ fontSize: '12px' }}></i>);
            } else {
                stars.push(<i key={i} className="bi bi-star text-warning" style={{ fontSize: '12px' }}></i>);
            }
        }
        return <span className="d-inline-flex align-items-center">{stars}</span>;
    };

    // Format currency
    const formatCurrency = (amount, currency) => {
        const symbols = {
            'INR': '₹',
            'USD': '$',
            'EUR': '€',
            'GBP': '£',
            'AED': 'AED ',
            'SGD': 'S$',
            'AUD': 'A$',
            'CAD': 'C$'
        };
        
        const symbol = symbols[currency] || currency;
        return `${symbol}${amount}`;
    };

    // Get meal plan label
    const getMealPlanLabel = (mealPlan) => {
        const plans = {
            'CP': 'CP → Breakfast only',
            'MAP': 'MAP → Breakfast + Lunch or Dinner',
            'AP': 'AP → Breakfast + Lunch + Dinner',
            'EP': 'EP → Room only',
            'CPAI': 'CPAI → Stay + Breakfast',
            'MAPAI': 'MAPAI → Stay + Breakfast + Lunch/Dinner',
            'APAI': 'APAI → Stay + Breakfast + Lunch + Dinner'
        };
        return plans[mealPlan] || mealPlan;
    };

    // Format date to display
    const formatDate = (dateString) => {
        if (!dateString || dateString === 'Not specified') return 'N/A';
        
        try {
            const date = new Date(dateString);
            return date.toLocaleDateString('en-US', {
                day: '2-digit',
                month: 'short',
                year: 'numeric'
            });
        } catch (error) {
            return dateString;
        }
    };

    // Get validity period for room details
    const getValidityPeriod = (roomDetails) => {
        if (!roomDetails || roomDetails.length === 0) return 'N/A';
        
        let earliestDate = null;
        let latestDate = null;
        
        roomDetails.forEach(room => {
            if (room.validFrom && room.validFrom !== 'Not specified') {
                const fromDate = new Date(room.validFrom);
                if (!earliestDate || fromDate < earliestDate) {
                    earliestDate = fromDate;
                }
            }
            
            if (room.validTo && room.validTo !== 'Not specified') {
                const toDate = new Date(room.validTo);
                if (!latestDate || toDate > latestDate) {
                    latestDate = toDate;
                }
            }
        });
        
        if (earliestDate && latestDate) {
            return `${formatDate(earliestDate)} to ${formatDate(latestDate)}`;
        } else if (earliestDate) {
            return `From ${formatDate(earliestDate)}`;
        } else if (latestDate) {
            return `Until ${formatDate(latestDate)}`;
        }
        
        return 'N/A';
    };

    // Pagination calculations
    const indexOfLastResult = currentPage * resultsPerPage;
    const indexOfFirstResult = indexOfLastResult - resultsPerPage;
    const currentResults = properties.slice(indexOfFirstResult, indexOfLastResult);
    const totalPages = Math.ceil(properties.length / resultsPerPage);

    if (loading) return <p>Loading...</p>;

    if (!user) {
        navigate("/");
    }

    return (
        <div id="layout-wrapper">
            <Header User={user} />
            <div className="main-content">
                <div className="page-content">
                    <div className="container-fluid">
                        <div className="card">
                            <div className="p-2">
                                <HotelTabs pageName="PROPERTIES" />
                            </div>
                            <div className="card-body p-3">
                                <div className="row mb-3">
                                    <div className="col-12">
                                        <div className="d-flex align-items-center mb-3">
                                            <div className="flex-grow-1">
                                                <h6 className="card-title text-primary mb-0">
                                                    <i className="bi bi-buildings me-2"></i>
                                                    Available Properties ({properties.length})
                                                </h6>
                                                <small className="text-muted">
                                                    Browse and contact DMCs directly via WhatsApp or Email
                                                </small>
                                            </div>
                                            <button
                                                className="btn btn-outline-primary btn-sm"
                                                onClick={fetchProperties}
                                                disabled={isLoading}
                                            >
                                                <i className="bi bi-arrow-clockwise me-2"></i>
                                                {isLoading ? "Refreshing..." : "Refresh"}
                                            </button>
                                        </div>

                                        {/* Loading State */}
                                        {isLoading && (
                                            <div className="text-center py-4">
                                                <div className="spinner-border text-primary spinner-border-sm" role="status">
                                                    <span className="visually-hidden">Loading...</span>
                                                </div>
                                                <p className="mt-2 small">
                                                    Loading properties...
                                                </p>
                                            </div>
                                        )}

                                        {/* Error State */}
                                        {error && !isLoading && (
                                            <div className="alert alert-danger text-center py-3">
                                                <i className="bi bi-exclamation-triangle mb-2 text-danger" style={{ fontSize: '32px' }}></i>
                                                <h6 className="mb-2">Error Loading Properties</h6>
                                                <p className="small text-muted mb-2">{error}</p>
                                                <button
                                                    type="button"
                                                    className="btn btn-outline-primary btn-sm"
                                                    onClick={fetchProperties}
                                                >
                                                    Try Again
                                                </button>
                                            </div>
                                        )}

                                        {/* No Properties State */}
                                        {!isLoading && !error && properties.length === 0 && (
                                            <div className="text-center py-4">
                                                <i className="bi bi-buildings mb-2 text-muted" style={{ fontSize: '48px' }}></i>
                                                <h6 className="mb-2">
                                                    No Properties Available
                                                </h6>
                                                <p className="small text-muted mb-3">
                                                    There are no properties available at the moment.
                                                </p>
                                            </div>
                                        )}

                                        {/* Properties List */}
                                        {!isLoading && !error && properties.length > 0 && (
                                            <>
                                                <div className="d-flex justify-content-between align-items-center mb-3 p-2 bg-light rounded">
                                                    <div>
                                                        <small className="fw-bold">
                                                            {properties.length} Properties
                                                        </small>
                                                        <small className="text-muted d-block">
                                                            Showing {currentResults.length} of {properties.length}
                                                        </small>
                                                    </div>
                                                    <div>
                                                        <small className="text-muted">
                                                            Page {currentPage}/{totalPages}
                                                        </small>
                                                    </div>
                                                </div>

                                                <div className="row row-cols-1 row-cols-md-2 row-cols-lg-3 row-cols-xl-4 g-3 mb-3">
                                                    {currentResults.map((property, index) => {
                                                        const lowestPrice = getLowestRoomPrice(property.roomDetails);
                                                        const validityDates = getValidityDates(property.roomDetails);
                                                        
                                                        return (
                                                            <div key={property.companyHotelId || index} className="col">
                                                                <div 
                                                                    className="card h-100 property-card border-light"
                                                                    style={{ 
                                                                        cursor: 'pointer',
                                                                        transition: 'all 0.2s ease',
                                                                        boxShadow: '0 1px 3px rgba(0,0,0,0.1)'
                                                                    }}
                                                                >
                                                                    <div className="position-relative">
                                                                        {property.hotelImage ? (
                                                                            <img
                                                                                src={property.hotelImage}
                                                                                className="card-img-top"
                                                                                alt={property.hotelName}
                                                                                style={{ height: '140px', objectFit: 'cover', width: '100%' }}
                                                                                onError={(e) => {
                                                                                    e.target.onerror = null;
                                                                                    e.target.src = `https://via.placeholder.com/300x140/cccccc/666666?text=${encodeURIComponent(property.hotelName?.substring(0, 20) || 'Property')}`;
                                                                                }}
                                                                            />
                                                                        ) : (
                                                                            <div className="card-img-top bg-gradient-primary d-flex align-items-center justify-content-center"
                                                                                 style={{ height: '140px', background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)' }}>
                                                                                <i className="bi bi-building text-white" style={{ fontSize: '36px' }}></i>
                                                                            </div>
                                                                        )}
                                                                        {property.isOwner && (
                                                                            <span className="position-absolute top-0 start-0 m-1 badge bg-success" style={{ fontSize: '10px' }}>
                                                                                <i className="bi bi-check-circle me-1" style={{ fontSize: '10px' }}></i>Owner
                                                                            </span>
                                                                        )}
                                                                        <span className="position-absolute top-0 end-0 m-1 badge bg-info" style={{ fontSize: '10px' }}>
                                                                            <i className="bi bi-tag me-1" style={{ fontSize: '10px' }}></i>DMC
                                                                        </span>
                                                                    </div>
                                                                    
                                                                    <div className="card-body p-2">
                                                                        {/* Property Name with Star Rating */}
                                                                        <div className="d-flex justify-content-between align-items-start mb-1">
                                                                            <h6 className="card-title text-truncate mb-0 me-1" style={{ fontSize: '14px' }}>
                                                                                {property.hotelName}
                                                                            </h6>
                                                                            <div className="d-flex align-items-center flex-shrink-0">
                                                                                {renderStars(property.starRating || 0)}
                                                                                <span className="ms-1 fw-bold text-warning" style={{ fontSize: '11px' }}>
                                                                                    {property.starRating || 'N/A'}
                                                                                </span>
                                                                            </div>
                                                                        </div>
                                                                        
                                                                        {/* Location */}
                                                                        <div className="d-flex align-items-center text-muted small mb-1">
                                                                            <i className="bi bi-geo-alt me-1 flex-shrink-0" style={{ fontSize: '11px' }}></i>
                                                                            <span className="text-truncate" style={{ fontSize: '11px' }}>
                                                                                {[property.city, property.country].filter(Boolean).join(', ')}
                                                                            </span>
                                                                        </div>
                                                                        
                                                                        {/* Lowest Room Price - Starts From */}
                                                                        {lowestPrice && (
                                                                            <div className="mb-1 p-1 bg-success bg-opacity-10 rounded">
                                                                                <small className="text-success d-flex align-items-center" style={{ fontSize: '11px' }}>
                                                                                    <i className="bi bi-tag-fill me-1" style={{ fontSize: '11px' }}></i>
                                                                                    <span className="fw-bold">Prices Starts from:</span>
                                                                                    <span className="ms-1 fw-bold text-success">
                                                                                        {formatCurrency(lowestPrice.price, lowestPrice.currency)}
                                                                                    </span>
                                                                                </small>
                                                                            </div>
                                                                        )}
                                                                        
                                                                        {/* Validity Dates - From and To */}
                                                                        {validityDates && (validityDates.from || validityDates.to) ? (
                                                                            <div className="mb-1 p-1 bg-light rounded">
                                                                                <div className="d-flex align-items-center text-muted">
                                                                                    <i className="bi bi-calendar-check me-1 text-primary" style={{ fontSize: '11px' }}></i>
                                                                                    <div style={{ fontSize: '10px' }}>
                                                                                        {validityDates.from && (
                                                                                            <span className="me-1">
                                                                                                <span className="fw-bold">Valid From:</span> {validityDates.from}
                                                                                            </span>
                                                                                        )}
                                                                                        {validityDates.to && (
                                                                                            <span>
                                                                                                <span className="fw-bold ms-1">To:</span> {validityDates.to}
                                                                                            </span>
                                                                                        )}
                                                                                        {validityDates.isActive && (
                                                                                            <span className="badge bg-success ms-1" style={{ fontSize: '8px', padding: '2px 4px' }}>Active</span>
                                                                                        )}
                                                                                    </div>
                                                                                </div>
                                                                            </div>
                                                                        ) : (
                                                                            <div className="mb-1 p-1 bg-light rounded">
                                                                                <small className="text-muted d-flex align-items-center" style={{ fontSize: '10px' }}>
                                                                                    <i className="bi bi-calendar-x me-1"></i>
                                                                                    No validity period
                                                                                </small>
                                                                            </div>
                                                                        )}
                                                                        
                                                                        {/* Room Details Available - Compact */}
                                                                        {property.roomDetails?.length > 0 && (
                                                                            <div className="mb-1">
                                                                                <small className="text-success d-flex align-items-center" style={{ fontSize: '10px' }}>
                                                                                    <i className="bi bi-check-circle me-1 flex-shrink-0" style={{ fontSize: '10px' }}></i>
                                                                                    <span>{property.roomDetails.length} room type(s)</span>
                                                                                </small>
                                                                            </div>
                                                                        )}
                                                                        
                                                                        {/* Property Type and Country Code - Compact */}
                                                                        <div className="mb-1">
                                                                            <span className="badge bg-primary bg-opacity-10 text-primary me-1" style={{ fontSize: '9px', padding: '2px 4px' }}>
                                                                                {property.accommodationType || 'Hotel'}
                                                                            </span>
                                                                            {property.countryCode && (
                                                                                <span className="badge bg-info bg-opacity-10 text-info me-1" style={{ fontSize: '9px', padding: '2px 4px' }}>
                                                                                    <i className="bi bi-flag me-1" style={{ fontSize: '9px' }}></i>
                                                                                    {property.countryCode}
                                                                                </span>
                                                                            )}
                                                                        </div>
                                                                    </div>
                                                                    
                                                                    <div className="card-footer bg-transparent border-top p-2">
                                                                        <div className="row g-1">
                                                                            {/* View Details & Prices Button */}
                                                                            <div className="col-6">
                                                                                <button
                                                                                    type="button"
                                                                                    className="btn btn-primary w-100"
                                                                                    style={{ padding: '3px 6px', fontSize: '11px' }}
                                                                                    onClick={(e) => {
                                                                                        e.stopPropagation();
                                                                                        openDetailsModal(property);
                                                                                    }}
                                                                                >
                                                                                    <i className="bi bi-eye me-1" style={{ fontSize: '11px' }}></i>
                                                                                    <i className="bi bi-tag ms-1" style={{ fontSize: '11px' }}></i>
                                                                                    View Details & Prices
                                                                                </button>
                                                                            </div>
                                                                            
                                                                            {/* Enquiry Button - NEW */}
                                                                            <div className="col-6">
                                                                                <button
                                                                                    type="button"
                                                                                    className="btn btn-secondary w-100"
                                                                                    style={{ padding: '3px 6px', fontSize: '11px' }}
                                                                                    onClick={(e) => {
                                                                                        e.stopPropagation();
                                                                                        openEnquiryModal(property);
                                                                                    }}
                                                                                >
                                                                                    <i className="bi bi-chat-dots me-1" style={{ fontSize: '11px' }}></i>
                                                                                    Send Enquiry
                                                                                </button>
                                                                            </div>
                                                                            
                                                                            {/* Contact Buttons */}
                                                                            <div className="col-6">
                                                                                <button
                                                                                    type="button"
                                                                                    className="btn btn-success w-100"
                                                                                    style={{ padding: '3px 6px', fontSize: '11px' }}
                                                                                    onClick={(e) => handleWhatsAppClick(property, e)}
                                                                                    disabled={!property.contactInfo?.whatsApp}
                                                                                    title={property.contactInfo?.whatsApp ? 
                                                                                        `Contact via WhatsApp: ${property.contactInfo.whatsApp}` : 
                                                                                        'WhatsApp not available'}
                                                                                >
                                                                                    <i className="bi bi-whatsapp me-1" style={{ fontSize: '11px' }}></i>
                                                                                    WhatsApp
                                                                                </button>
                                                                            </div>
                                                                            
                                                                            <div className="col-6">
                                                                                <button
                                                                                    type="button"
                                                                                    className="btn btn-warning w-100"
                                                                                    style={{ padding: '3px 6px', fontSize: '11px' }}
                                                                                    onClick={(e) => handleEmailClick(property, e)}
                                                                                    disabled={!property.contactInfo?.email}
                                                                                    title={property.contactInfo?.email ? 
                                                                                        `Contact via Email: ${property.contactInfo.email}` : 
                                                                                        'Email not available'}
                                                                                >
                                                                                    <i className="bi bi-envelope me-1" style={{ fontSize: '11px' }}></i>
                                                                                    Email
                                                                                </button>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        );
                                                    })}
                                                </div>
                                                
                                                {/* Pagination - Compact */}
                                                {totalPages > 1 && (
                                                    <nav aria-label="Properties pagination" className="mt-3">
                                                        <ul className="pagination pagination-sm justify-content-center flex-wrap mb-0">
                                                            <li className={`page-item ${currentPage === 1 ? 'disabled' : ''}`}>
                                                                <button
                                                                    className="page-link"
                                                                    onClick={() => setCurrentPage(1)}
                                                                    disabled={currentPage === 1}
                                                                    style={{ padding: '4px 8px', fontSize: '11px' }}
                                                                >
                                                                    First
                                                                </button>
                                                            </li>
                                                            <li className={`page-item ${currentPage === 1 ? 'disabled' : ''}`}>
                                                                <button
                                                                    className="page-link"
                                                                    onClick={() => setCurrentPage(prev => Math.max(1, prev - 1))}
                                                                    disabled={currentPage === 1}
                                                                    style={{ padding: '4px 8px', fontSize: '11px' }}
                                                                >
                                                                    Prev
                                                                </button>
                                                            </li>
                                                            
                                                            {Array.from({ length: Math.min(3, totalPages) }, (_, i) => {
                                                                let pageNum;
                                                                if (totalPages <= 3) {
                                                                    pageNum = i + 1;
                                                                } else if (currentPage <= 2) {
                                                                    pageNum = i + 1;
                                                                } else if (currentPage >= totalPages - 1) {
                                                                    pageNum = totalPages - 2 + i;
                                                                } else {
                                                                    pageNum = currentPage - 1 + i;
                                                                }
                                                                
                                                                return (
                                                                    <li key={pageNum} className={`page-item ${currentPage === pageNum ? 'active' : ''}`}>
                                                                        <button
                                                                            className="page-link"
                                                                            onClick={() => setCurrentPage(pageNum)}
                                                                            style={{ padding: '4px 8px', fontSize: '11px' }}
                                                                        >
                                                                            {pageNum}
                                                                        </button>
                                                                    </li>
                                                                );
                                                            })}
                                                            
                                                            <li className={`page-item ${currentPage === totalPages ? 'disabled' : ''}`}>
                                                                <button
                                                                    className="page-link"
                                                                    onClick={() => setCurrentPage(prev => Math.min(totalPages, prev + 1))}
                                                                    disabled={currentPage === totalPages}
                                                                    style={{ padding: '4px 8px', fontSize: '11px' }}
                                                                >
                                                                    Next
                                                                </button>
                                                            </li>
                                                            <li className={`page-item ${currentPage === totalPages ? 'disabled' : ''}`}>
                                                                <button
                                                                    className="page-link"
                                                                    onClick={() => setCurrentPage(totalPages)}
                                                                    disabled={currentPage === totalPages}
                                                                    style={{ padding: '4px 8px', fontSize: '11px' }}
                                                                >
                                                                    Last
                                                                </button>
                                                            </li>
                                                        </ul>
                                                    </nav>
                                                )}
                                            </>
                                        )}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            {/* Property Details Modal */}
            {showDetailsModal && selectedPropertyDetails && (
                <div className="modal fade show" style={{ display: 'block', backgroundColor: 'rgba(0,0,0,0.5)' }}>
                    <div className="modal-dialog modal-xl modal-dialog-centered modal-dialog-scrollable">
                        <div className="modal-content">
                            <div className="modal-header bg-primary py-2">
                                <h6 className="modal-title text-white">
                                    <i className="bi bi-building me-2 text-white"></i>
                                    {selectedPropertyDetails.hotelName}
                                </h6>
                                <button 
                                    type="button" 
                                    className="btn-close btn-close-white"
                                    onClick={closeDetailsModal}
                                    style={{ fontSize: '12px' }}
                                ></button>
                            </div>
                          <div className="modal-body">
                                <div className="row">
                                    {/* Left Column - Image and Basic Info */}
                                     <div className="col-md-4">
                                        {/* Property Image */}
                                       <div className="mb-3">
                                            {selectedPropertyDetails.hotelImage ? (
                                                <img
                                                    src={selectedPropertyDetails.hotelImage}
                                                    className="img-fluid rounded shadow"
                                                    alt={selectedPropertyDetails.hotelName}
                                                    style={{ 
                                                        width: '100%', 
                                                        height: '250px',
                                                        objectFit: 'cover'
                                                    }}
                                                    onError={(e) => {
                                                        e.target.onerror = null;
                                                        e.target.src = `https://via.placeholder.com/400x250/cccccc/666666?text=${encodeURIComponent(selectedPropertyDetails.hotelName?.substring(0, 30) || 'Property')}`;
                                                    }}
                                                />
                                            ) : (
                                                <div 
                                                    className="bg-gradient-primary rounded shadow d-flex align-items-center justify-content-center"
                                                    style={{ 
                                                        height: '250px',
                                                        background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)'
                                                    }}
                                                >
                                                    <i className="bi bi-building text-white" style={{ fontSize: '64px' }}></i>
                                                </div>
                                            )}
                                        </div>
                                        
                                        {/* Star Rating */}
                                        <div className="card border-warning mb-3">
                                            <div className="card-body text-center">
                                                <h6 className="card-title text-warning mb-2">
                                                    <i className="bi bi-star me-1"></i>
                                                    Star Rating
                                                </h6>
                                                <div className="d-flex justify-content-center align-items-center">
                                                    {renderStars(selectedPropertyDetails.starRating || 0)}
                                                    <span className="ms-2 fw-bold fs-5">
                                                        {selectedPropertyDetails.starRating || 'N/A'} Star
                                                    </span>
                                                </div>
                                            </div>
                                        </div>
                                        
                                        {/* Property Type */}
                                        <div className="card border-primary mb-3">
                                            <div className="card-body text-center">
                                                <h6 className="card-title text-primary mb-2">
                                                    <i className="bi bi-building me-1"></i>
                                                    Property Type
                                                </h6>
                                                <h4 className="text-primary mb-0">
                                                    {selectedPropertyDetails.accommodationType || 'Hotel'}
                                                </h4>
                                            </div>
                                        </div>
                                        
                                       
                                        
                                        {/* Contact Buttons */}
                                        {selectedPropertyDetails.contactInfo && (
                                            <div className="card border-info">
                                                <div className="card-body text-center">
                                                    <h6 className="card-title text-info mb-3">
                                                        <i className="bi bi-telephone me-1"></i>
                                                        Contact DMC Directly
                                                    </h6>
                                                    <div className="d-grid gap-2">
                                                        {selectedPropertyDetails.contactInfo.whatsApp && (
                                                            <button
                                                                className="btn btn-success"
                                                                onClick={(e) => handleWhatsAppClick(selectedPropertyDetails, e)}
                                                            >
                                                                <i className="bi bi-whatsapp me-2"></i>
                                                                WhatsApp
                                                            </button>
                                                        )}
                                                        {selectedPropertyDetails.contactInfo.email && (
                                                            <button
                                                                className="btn btn-primary"
                                                                onClick={(e) => handleEmailClick(selectedPropertyDetails, e)}
                                                            >
                                                                <i className="bi bi-envelope me-2"></i>
                                                                Send Email
                                                            </button>
                                                        )}
                                                        {/* Enquiry Button in Modal */}
                                                        <button
                                                            className="btn btn-primary"
                                                            onClick={() => {
                                                                closeDetailsModal();
                                                                openEnquiryModal(selectedPropertyDetails);
                                                            }}
                                                            style={{ backgroundColor: '#28a745', borderColor: '#28a745' }}
                                                        >
                                                            <i className="bi bi-chat-dots me-2"></i>
                                                            Send Enquiry
                                                        </button>
                                                    </div>
                                                </div>
                                            </div>
                                        )}
                                    </div>
                                    
                                    {/* Right Column - Details */}
                                    <div className="col-md-8">
                                        {/* Location Details */}
                                        <div className="card border-success mb-3">
                                            <div className="card-header bg-success bg-opacity-10">
                                                <h6 className="mb-0 text-success">
                                                    <i className="bi bi-geo-alt me-2"></i>
                                                    Location Details
                                                </h6>
                                            </div>
                                            <div className="card-body">
                                                <div className="row">
                                                    <div className="col-md-6 mb-2">
                                                        <strong>Address:</strong>
                                                        <p className="mb-1">{selectedPropertyDetails.address || 'Not Available'}</p>
                                                    </div>
                                                    <div className="col-md-3 mb-2">
                                                        <strong>City:</strong>
                                                        <p className="mb-1">{selectedPropertyDetails.city || 'N/A'}</p>
                                                    </div>
                                                    <div className="col-md-3 mb-2">
                                                        <strong>State:</strong>
                                                        <p className="mb-1">{selectedPropertyDetails.state || 'N/A'}</p>
                                                    </div>
                                                    <div className="col-md-4 mb-2">
                                                        <strong>Country:</strong>
                                                        <p className="mb-1">{selectedPropertyDetails.country || 'N/A'}</p>
                                                    </div>
                                                    <div className="col-md-4 mb-2">
                                                        <strong>Postal Code:</strong>
                                                        <p className="mb-1">{selectedPropertyDetails.postalCode || 'N/A'}</p>
                                                    </div>
                                                    <div className="col-md-4 mb-2">
                                                        <strong>Country Code:</strong>
                                                        <p className="mb-1">{selectedPropertyDetails.countryCode || 'N/A'}</p>
                                                    </div>
                                                    {selectedPropertyDetails.latitude && selectedPropertyDetails.longitude && (
                                                        <div className="col-12">
                                                            <a
                                                                href={`https://www.google.com/maps?q=${selectedPropertyDetails.latitude},${selectedPropertyDetails.longitude}`}
                                                                target="_blank"
                                                                rel="noopener noreferrer"
                                                                className="btn btn-sm btn-primary"
                                                            >
                                                                <i className="bi bi-geo-alt me-1"></i>
                                                                View on Google Maps
                                                            </a>
                                                        </div>
                                                    )}
                                                </div>
                                            </div>
                                        </div>
                                        
                                        {/* Contact Details */}
                                        {selectedPropertyDetails.contactInfo && (
                                            <div className="card border-info mb-3">
                                                <div className="card-header bg-info bg-opacity-10">
                                                    <h6 className="mb-0 text-info">
                                                        <i className="bi bi-person me-2"></i>
                                                        Contact Details
                                                    </h6>
                                                </div>
                                                <div className="card-body">
                                                    <div className="row">
                                                        <div className="col-md-6 mb-2">
                                                            <strong>Contact Name:</strong>
                                                            <p className="mb-1">{selectedPropertyDetails.contactInfo.contactName || 'Not Available'}</p>
                                                        </div>
                                                        <div className="col-md-6 mb-2">
                                                            <strong>Email:</strong>
                                                            <p className="mb-1">{selectedPropertyDetails.contactInfo.email || 'Not Available'}</p>
                                                        </div>
                                                        <div className="col-md-6 mb-2">
                                                            <strong>Phone:</strong>
                                                            <p className="mb-1">{selectedPropertyDetails.contactInfo.phone || 'Not Available'}</p>
                                                        </div>
                                                        <div className="col-md-6 mb-2">
                                                            <strong>WhatsApp:</strong>
                                                            <p className="mb-1">{selectedPropertyDetails.contactInfo.whatsApp || 'Not Available'}</p>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        )}
                                        
                                        {/* Room Details */}
                                        {selectedPropertyDetails.roomDetails && selectedPropertyDetails.roomDetails.length > 0 && (
                                            <div className="card border-primary mb-3">
                                                <div className="card-header bg-primary bg-opacity-10">
                                                    <div className="d-flex justify-content-between align-items-center">
                                                        <h6 className="mb-0 text-primary">
                                                            <i className="bi bi-bed me-2"></i>
                                                            Available Room Types
                                                        </h6>
                                                        <span className="badge bg-primary">
                                                            Valid: {getValidityPeriod(selectedPropertyDetails.roomDetails)}
                                                        </span>
                                                    </div>
                                                </div>
                                                <div className="card-body">
                                                    <div className="table-responsive">
                                                        <table className="table table-hover">
                                                            <thead className="table-light">
                                                                <tr>
                                                                    <th>Room Type</th>
                                                                    <th>Meal Plan</th>
                                                                    <th>Price</th>
                                                                    <th>Extra Bed</th>
                                                                    <th>Child w/o Bed</th>
                                                                </tr>
                                                            </thead>
                                                            <tbody>
                                                                {selectedPropertyDetails.roomDetails.map((room, index) => (
                                                                    <tr key={index}>
                                                                        <td>{room.roomType}</td>
                                                                        <td>{getMealPlanLabel(room.mealPlan)}</td>
                                                                        <td>
                                                                            <strong className="text-success">
                                                                                {formatCurrency(room.price, room.currency)}
                                                                            </strong>
                                                                        </td>
                                                                        <td>
                                                                            {room.extraBedPrice ? (
                                                                                <span className="badge bg-success">
                                                                                    {formatCurrency(room.extraBedPrice, room.currency)}
                                                                                </span>
                                                                            ) : (
                                                                                <span className="badge bg-secondary">Not Available</span>
                                                                            )}
                                                                        </td>
                                                                        <td>
                                                                            {room.childWithoutBedPrice ? (
                                                                                <span className="badge bg-info">
                                                                                    {formatCurrency(room.childWithoutBedPrice, room.currency)}
                                                                                </span>
                                                                            ) : (
                                                                                <span className="badge bg-secondary">Not Available</span>
                                                                            )}
                                                                        </td>
                                                                    </tr>
                                                                ))}
                                                            </tbody>
                                                        </table>
                                                    </div>
                                                </div>
                                            </div>
                                        )}
                                        
                                        {/* Amenities */}
                                        {selectedPropertyDetails.amenities && selectedPropertyDetails.amenities.length > 0 && (
                                            <div className="card border-success mb-3">
                                                <div className="card-header bg-success bg-opacity-10">
                                                    <h6 className="mb-0 text-success">
                                                        <i className="bi bi-wifi me-2"></i>
                                                        Amenities & Facilities
                                                    </h6>
                                                </div>
                                                <div className="card-body">
                                                    <div className="row">
                                                        {selectedPropertyDetails.amenities.map((amenity, index) => (
                                                            <div key={index} className="col-md-6 mb-2">
                                                                <i className="bi bi-check-circle-fill text-success me-2"></i>
                                                                {amenity.point}
                                                            </div>
                                                        ))}
                                                    </div>
                                                </div>
                                            </div>
                                        )}
                                        
                                        {/* Policies */}
                                        <div className="row">
                                            {/* Terms & Conditions */}
                                            {selectedPropertyDetails.termsAndConditions && selectedPropertyDetails.termsAndConditions.length > 0 && (
                                                <div className="col-md-6 mb-3">
                                                    <div className="card border-warning h-100">
                                                        <div className="card-header bg-warning bg-opacity-10">
                                                            <h6 className="mb-0 text-warning">
                                                                <i className="bi bi-file-text me-2"></i>
                                                                Terms & Conditions
                                                            </h6>
                                                        </div>
                                                        <div className="card-body">
                                                            <ul className="list-group list-group-flush">
                                                                {selectedPropertyDetails.termsAndConditions.slice(0, 5).map((term, index) => (
                                                                    <li key={index} className="list-group-item px-0">
                                                                        <i className="bi bi-dot text-warning me-2"></i>
                                                                        {term.point}
                                                                    </li>
                                                                ))}
                                                            </ul>
                                                        </div>
                                                    </div>
                                                </div>
                                            )}
                                            
                                            {/* Cancellation Policy */}
                                            {selectedPropertyDetails.cancellationPolicy && selectedPropertyDetails.cancellationPolicy.length > 0 && (
                                                <div className="col-md-6 mb-3">
                                                    <div className="card border-danger h-100">
                                                        <div className="card-header bg-danger bg-opacity-10">
                                                            <h6 className="mb-0 text-danger">
                                                                <i className="bi bi-calendar-x me-2"></i>
                                                                Cancellation Policy
                                                            </h6>
                                                        </div>
                                                        <div className="card-body">
                                                            <ul className="list-group list-group-flush">
                                                                {selectedPropertyDetails.cancellationPolicy.slice(0, 5).map((policy, index) => (
                                                                    <li key={index} className="list-group-item px-0">
                                                                        <i className="bi bi-dot text-danger me-2"></i>
                                                                        {policy.point}
                                                                    </li>
                                                                ))}
                                                            </ul>
                                                        </div>
                                                    </div>
                                                </div>
                                            )}
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="modal-footer">
                                <button
                                    type="button"
                                    className="btn btn-danger"
                                    onClick={closeDetailsModal}
                                >
                                    Close
                                </button>
                                <button
                                    type="button"
                                    className="btn btn-primary"
                                    onClick={() => {
                                        closeDetailsModal();
                                        openEnquiryModal(selectedPropertyDetails);
                                    }}
                                    style={{ backgroundColor: '#28a745', borderColor: '#28a745' }}
                                >
                                    <i className="bi bi-chat-dots me-1"></i>
                                    Send Enquiry
                                </button>
                            </div>
                        </div>
                        </div>
                    </div>
            )}

            {/* Enquiry Modal */}
            {showEnquiryModal && selectedProperty && (
                <div className="modal fade show" style={{ display: 'block', backgroundColor: 'rgba(0,0,0,0.5)' }}>
                    <div className="modal-dialog modal-lg modal-dialog-centered">
                        <div className="modal-content">
                            <div className="modal-header bg-success text-white py-2">
                                <h6 className="modal-title">
                                    <i className="bi bi-chat-dots me-2"></i>
                                    Send Enquiry - {selectedProperty.hotelName}
                                </h6>
                                <button 
                                    type="button" 
                                    className="btn-close btn-close-white"
                                    onClick={closeEnquiryModal}
                                    style={{ fontSize: '12px' }}
                                ></button>
                            </div>
                            <form onSubmit={handleEnquirySubmit}>
                                <div className="modal-body">
                                    {/* Property Info Banner */}
                                    <div className="alert alert-info mb-3 py-2">
                                        <div className="d-flex align-items-center">
                                            <div className="flex-shrink-0">
                                                <i className="bi bi-building fs-5"></i>
                                            </div>
                                            <div className="flex-grow-1 ms-2">
                                                <p className="mb-0 small">
                                                    <strong>{selectedProperty.hotelName}</strong><br/>
                                                    <small>
                                                        {selectedProperty.city && `${selectedProperty.city}, `}
                                                        {selectedProperty.country}
                                                        {selectedProperty.starRating && ` • ${selectedProperty.starRating} Star`}
                                                    </small>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                    
                                    <div className="row g-2">
                                        {/* Check-in/Check-out */}
                                        <div className="col-md-6">
                                            <label className="form-label small">Check-in Date *</label>
                                            <input
                                                type="date"
                                                className="form-control form-control-sm"
                                                name="checkIn"
                                                value={enquiryData.checkIn}
                                                onChange={handleEnquiryChange}
                                                required
                                            />
                                        </div>
                                        <div className="col-md-6">
                                            <label className="form-label small">Check-out Date *</label>
                                            <input
                                                type="date"
                                                className="form-control form-control-sm"
                                                name="checkOut"
                                                value={enquiryData.checkOut}
                                                onChange={handleEnquiryChange}
                                                required
                                            />
                                        </div>
                                        
                                        {/* Room Configuration */}
                                        <div className="col-md-3">
                                            <label className="form-label small">Adults *</label>
                                            <input
                                                type="number"
                                                className="form-control form-control-sm"
                                                name="adults"
                                                value={enquiryData.adults}
                                                onChange={handleNumberChange}
                                                min="1"
                                                max="20"
                                                required
                                            />
                                        </div>
                                        <div className="col-md-3">
                                            <label className="form-label small">Children</label>
                                            <input
                                                type="number"
                                                className="form-control form-control-sm"
                                                name="children"
                                                value={enquiryData.children}
                                                onChange={handleNumberChange}
                                                min="0"
                                                max="20"
                                            />
                                        </div>
                                        <div className="col-md-3">
                                            <label className="form-label small">Rooms *</label>
                                            <input
                                                type="number"
                                                className="form-control form-control-sm"
                                                name="rooms"
                                                value={enquiryData.rooms}
                                                onChange={handleNumberChange}
                                                min="1"
                                                max="10"
                                                required
                                            />
                                        </div>
                                        <div className="col-md-3">
                                            <label className="form-label small">Total Guests</label>
                                            <div className="form-control form-control-sm bg-light">
                                                {parseInt(enquiryData.adults) + parseInt(enquiryData.children)}
                                            </div>
                                        </div>
                                        
                                        {/* Customer Details */}
                                        <div className="col-md-4">
                                            <label className="form-label small">Your Name *</label>
                                            <input
                                                type="text"
                                                className="form-control form-control-sm"
                                                name="customerName"
                                                value={enquiryData.customerName}
                                                onChange={handleEnquiryChange}
                                                placeholder="Enter your name"
                                                required
                                            />
                                        </div>
                                        <div className="col-md-4">
                                            <label className="form-label small">Email *</label>
                                            <input
                                                type="email"
                                                className="form-control form-control-sm"
                                                name="customerEmail"
                                                value={enquiryData.customerEmail}
                                                onChange={handleEnquiryChange}
                                                placeholder="Enter your email"
                                                required
                                            />
                                        </div>
                                        <div className="col-md-4">
                                            <label className="form-label small">Phone *</label>
                                            <input
                                                type="tel"
                                                className="form-control form-control-sm"
                                                name="customerPhone"
                                                value={enquiryData.customerPhone}
                                                onChange={handleEnquiryChange}
                                                placeholder="Enter your phone number"
                                                required
                                            />
                                        </div>
                                        
                                        {/* Special Requests */}
                                        <div className="col-12">
                                            <label className="form-label small">Special Requests</label>
                                            <textarea
                                                className="form-control form-control-sm"
                                                name="specialRequests"
                                                value={enquiryData.specialRequests}
                                                onChange={handleEnquiryChange}
                                                placeholder="Any special requests or additional information (room preferences, dietary requirements, etc.)..."
                                                rows="2"
                                            />
                                        </div>
                                        
                                        {/* Room Type Preference */}
                                        {selectedProperty.roomDetails && selectedProperty.roomDetails.length > 0 && (
                                            <div className="col-12">
                                                <label className="form-label small">Room Type Preference (Optional)</label>
                                                <select 
                                                    className="form-select form-select-sm"
                                                    name="roomPreference"
                                                    value={enquiryData.roomPreference}
                                                    onChange={handleEnquiryChange}
                                                >
                                                    <option value="">Select preferred room type</option>
                                                    {selectedProperty.roomDetails.map((room, index) => (
                                                        <option key={index} value={room.roomType}>
                                                            {room.roomType} - {formatCurrency(room.price, room.currency)} ({getMealPlanLabel(room.mealPlan)})
                                                        </option>
                                                    ))}
                                                </select>
                                            </div>
                                        )}
                                    </div>
                                </div>
                                <div className="modal-footer py-2">
                                    <button
                                        type="button"
                                        className="btn btn-danger btn-sm"
                                        onClick={closeEnquiryModal}
                                        disabled={isSubmittingEnquiry}
                                    >
                                        Cancel
                                    </button>
                                    <button
                                        type="submit"
                                        className="btn btn-success btn-sm"
                                        disabled={isSubmittingEnquiry}
                                        style={{ backgroundColor: '#28a745', borderColor: '#28a745' }}
                                    >
                                        <i className="bi bi-send me-1"></i>
                                        {isSubmittingEnquiry ? "Submitting..." : "Submit Enquiry"}
                                    </button>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            )}

            {/* Custom CSS */}
            <style jsx>{`
                .property-card:hover {
                    border-color: #0d6efd !important;
                    box-shadow: 0 2px 5px rgba(0,0,0,0.1) !important;
                }
                
                .property-card {
                    font-size: 12px;
                }
                
                .card-body {
                    padding: 0.5rem !important;
                }
                
                .card-footer {
                    padding: 0.5rem !important;
                }
                
                .badge {
                    font-weight: 500;
                }
                
                .btn-success {
                    background-color: #25d366;
                    border-color: #25d366;
                }
                
                .btn-success:hover {
                    background-color: #1da851;
                    border-color: #1da851;
                }
                
                .btn-info {
                    background-color: #0dcaf0;
                    border-color: #0dcaf0;
                }
                
                .btn-info:hover {
                    background-color: #0ba6c8;
                    border-color: #0ba6c8;
                }
                
                .btn-success:disabled, .btn-info:disabled {
                    opacity: 0.5;
                    cursor: not-allowed;
                }
                
                .modal-backdrop {
                    background-color: rgba(0,0,0,0.5);
                }
                
                .modal-content {
                    border: none;
                    box-shadow: 0 5px 15px rgba(0,0,0,0.3);
                }
                
                .modal-header {
                    border-bottom: 1px solid rgba(255,255,255,0.1);
                }
                
                .modal-footer {
                    border-top: 1px solid #dee2e6;
                }
                
                @media (max-width: 768px) {
                    .container-fluid {
                        padding-left: 10px;
                        padding-right: 10px;
                    }
                    
                    .row {
                        margin-left: -5px;
                        margin-right: -5px;
                    }
                    
                    .col {
                        padding-left: 5px;
                        padding-right: 5px;
                    }
                    
                    .card-footer .row {
                        margin: 0 -2px;
                    }
                    
                    .card-footer .col-6 {
                        padding: 0 2px;
                    }
                    
                    .modal-dialog {
                        margin: 10px;
                    }
                    
                    .modal-body {
                        padding: 15px;
                    }
                } 
            `}</style>
        </div>
    );
};

export default PropertiesList;